export default __webpack_public_path__ + "static/media/dj.71cf15bf.svg";